module.exports = function(app) {
    app.controller("pages.spending.clientListSelection", ["$scope", "session","services", "storage","coremetrics","spendingResourceServices","$cookies","invisibleForm",'educationalMaterialService', '$window',
        function( $scope, session, services, storage, coremetrics, spendingResourceServices, $cookies, invisibleForm, educationalMaterialService, $window) {

            $scope.viewState = 'loading';
            $scope.clientListSelection="";

            var memberInfo = session.data.memberInfo;
            var spendingAccountDebitCard = function (fullMemberInfo) {
                fullMemberInfo = fullMemberInfo || session.data.memberInfo;
                var clientDebitList = [];
                var today = new Date();
                today.setHours(0);
                today.setMinutes(0);
                today.setSeconds(0);
                today.setMilliseconds(0);
                for (var i = 0; i < fullMemberInfo.clientList.length; i++) {
                    var client = fullMemberInfo.clientList[i];
                     clientDebitList.push(client);
                }
                return clientDebitList;
            };
            $scope.clientDebitList = spendingAccountDebitCard(memberInfo);
            $scope.reroute = function (){
                var clientCatch = sessionStorage.incomingUrl;
                console.log("clientCatch: ",clientCatch);
                sessionStorage.incomingUrl = "";
                if(clientCatch === "receipts"){
                    $window.location = '/member/spending/newReceipt';
                }

                if (clientCatch === "claim") {
                    $window.location = '/member/spending/newClaims';
                }
            };
            // redirect logic if there is only one client
            /*if($scope.clientDebitList && $scope.clientDebitList.length <= 1){
                $scope.reroute();
            }*/

            $scope.medBenefits = function() {
                $window.location = '/member/coverage/medical-benefits';
            };
        }]);
};